export default __webpack_public_path__ + "static/media/globe-timezone.23114797.svg";